import { useDispatch, useSelector } from 'react-redux'
import { animated, useSpring } from '@react-spring/web'
//
import { selectIsReadyToShowSplashAd, selectRouteDetectMessage } from 'redux/selector/app'
//
import preBootAnimation from './animation/pre-boot.json'
//
import { Wrapper, SplashImage, LoadingBox, Text, SplashText, StyledAnimation, SplashBackground } from './Styled'
import actions from 'redux/action'
import SplashInviteCode from '../../SplashInviteCode'
import SplashVersionNumber from 'component/SplashVersionNumber'
import StartupConnectionReminderInlineTrigger from 'component/StartupConnectionReminder/InlineTrigger'
import StartupConnectionReminder from 'component/StartupConnectionReminder'
import EntryDomainUpdateTooltip from 'component/EntryDomainUpdateTooltip'
import { useState } from 'react'

/** App 入站讀取資料時的顯示畫面 */
export default function Splash() {
  const isReadyToShowSplashAd = useSelector(selectIsReadyToShowSplashAd)
  const routeDetectMessage = useSelector(selectRouteDetectMessage)
  const dispatch = useDispatch()
  const [connectionReminderOpen, setConnectionReminderOpen] = useState(false)

  const springStyles = useSpring({
    backgroundColor: 'black',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: isReadyToShowSplashAd ? 0 : 1,
    config: { duration: 800 },
    /** 動畫結束 */
    onRest: function () {
      dispatch(actions.updateIsShowingLaunchSplash(false))
    },
  })

  return (
    <>
      <Wrapper>
        <animated.div style={springStyles}>
          <SplashBackground />
          <SplashImage />
          <SplashText />
          <LoadingBox>
            <StyledAnimation animationData={preBootAnimation} />
            {routeDetectMessage && <Text>{routeDetectMessage}</Text>}
            <StartupConnectionReminderInlineTrigger
              active
              onOpen={() => setConnectionReminderOpen(true)}
              textColor="#ffffff"
            />
          </LoadingBox>
          <StartupConnectionReminder
            isOpen={connectionReminderOpen}
            onAction={() => setConnectionReminderOpen(false)}
          />
          <EntryDomainUpdateTooltip />
          <SplashInviteCode />
          <SplashVersionNumber />
        </animated.div>
      </Wrapper>
    </>
  )
}
